// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.uploader-status ::ng-deep .mat-mdc-progress-spinner circle, .mat-mdc-progress-spinner circle {
  stroke: var(--theme-main-color, #055C8D);
}

.overlay {
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.286);
  z-index: 9000;
  top: 0;
  left: 0;
  position: fixed;
}

.appAlert {
  width: 80%;
  position: fixed;
  left: 50%;
  margin-left: -37.5%;
  z-index: 9000;
  text-align: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
